<add-recipient-address
  (onEnterKey)="recipientAddressAdded($event)"
  (onValueChange)="onKeyPress($event)"
  [recipientAddressError]="recipientError"
  (destinationTagChange)="this.destinationTag = $event"
  [destinationTagError]="destinationTagError"
  [wallet]="wallet">
</add-recipient-address>
@if (!(searchString.length > 0)) {
  <recently-used-recipients
    (recentContactSelected)="selectContact($event)"
  [asset]="selectedAsset"></recently-used-recipients>
}
<select-contact
  [asset]="selectedAsset"
  [currentSearchString]="searchString"
  (onMultiplePossibleRecipients)="onMultiplePossibleRecipients($event)"
  (onSelectContact)="selectContact($event)"
(onSelectNewAddress)="selectNewAddress()"></select-contact>
